var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSiteTemplateLocBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.032,
    height: 17.1,
    viewBox: "0 0 16.032 17.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-point",
    transform: "translate(-16 46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M28.282,8.551a7.778,7.778,0,0,0,.354-2.233A6.318,6.318,0,1,0,16,6.318a9.047,9.047,0,0,0,.956,3.79,18.7,18.7,0,0,0,2.054,3.321,26.678,26.678,0,0,0,2.971,3.307l.337.306.337-.306c.031-.028.664-.606,1.514-1.55a4.291,4.291,0,1,0,4.113-6.636Zm-5.963,7.122C21.1,14.475,17,10.157,17,6.318a5.316,5.316,0,1,1,10.632,0,7.025,7.025,0,0,1-.4,2.229,4.292,4.292,0,0,0-3.545,5.673C23.123,14.864,22.628,15.369,22.318,15.672Zm5.421.426a3.29,3.29,0,1,1,3.29-3.29A3.294,3.294,0,0,1,27.74,16.1Z",
    transform: "translate(0 -46)",
    fill: "#417286"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M311.455,325h-1v1.453H309v1h1.453v1.453h1v-1.453h1.453v-1h-1.453Z",
    transform: "translate(-283.214 -360.145)",
    fill: "#e85256"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M117.29,98.145a3.145,3.145,0,1,0-.921,2.224A3.124,3.124,0,0,0,117.29,98.145Zm-1.63,1.515a2.143,2.143,0,1,1,.628-1.515A2.129,2.129,0,0,1,115.661,99.66Z",
    transform: "translate(-91.827 -137.827)",
    fill: "#417286"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteTemplateLocBlue);
export default __webpack_public_path__ + "static/media/SiteTemplateLocBlue.67da387665ef121735dd14fb2015aba6.svg";
export { ForwardRef as ReactComponent };